<template>
  <!--<navbar btn-background="bg-gradient-primary" />-->
  <main class="mt-0 main-content main-content-bg">
    <section>
      <div class="page-header min-vh-100" style="background: rgb(81,112,255);
        background: linear-gradient(135deg, rgba(81,112,255,1) 0%, rgba(203,12,159,1) 100%);">
        <div class="container">
          <div class="row" style="justify-content: center;">
            <div id="logoTomate" class="col-6" style="display: flex;
              justify-content: center;">
              <img src="../assets/img/ToMate.png" class="navbar-brand-img h-100" alt="main_logo" style="
              display: block;
              width: auto;"/>
            </div>
            <div class="mx-auto col-xl-6 col-lg-6 col-md-6 d-flex flex-column">

              <div id="container" class="container" style="width: fit-content;">
                <soft-alert v-show="passwordsNotEqual === true" color="danger" icon="ni ni-like-2 ni-lg" dismissible>
                  <strong>Passwords must be the same</strong>
                </soft-alert>
                <soft-alert v-show="emailValid === true" color="danger" icon="ni ni-like-2 ni-lg" dismissible>
                  <strong>Introduce a valid email</strong>
                </soft-alert>
                <soft-alert v-show="passwordNotLong === true" color="danger" icon="ni ni-like-2 ni-lg" dismissible>
                  <strong>Password must be longer than 8 characters</strong>
                </soft-alert>
                <soft-alert v-show="companyEmpty === true" color="danger" icon="ni ni-like-2 ni-lg" dismissible>
                  <strong>Company field must not be empty</strong>
                </soft-alert>
                <soft-alert v-show="userExists === true" color="danger" icon="ni ni-like-2 ni-lg" dismissible>
                  <strong>There was an error, try again!</strong>
                </soft-alert>
                <soft-alert v-show="errorServer === true" color="danger" icon="ni ni-like-2 ni-lg" dismissible>
                  <strong>There was an error, try again!</strong>
                </soft-alert>
                <soft-alert v-show="showResponseMessage === true" color="danger" icon="ni ni-like-2 ni-lg" dismissible>
                  <strong>{{ responseMessage }}</strong>
                </soft-alert>
                <div class="card z-index-0">
                  <div class="pb-0 card-header text-start">
                    <h3 class="font-weight-bolder text-success">
                      Register for free
                    </h3>
                    <p class="mb-0">Unleash all the power of AI in your messaging tasks</p>
                  </div>
                  <div class="card-body">
                    
                      <div class="mb-3">
                        <input
                          id="email"
                          type="email"
                          class="form-control"
                          name="email"
                          v-model="email"
                          placeholder="Email"
                          isRequired="required"
                        />
                      </div>
                      <div class="mb-3">
                        <input
                          id="password"
                          type="password"
                          class="form-control"
                          name="password"
                          v-model="password1"
                          placeholder="Password"
                          isRequired="required"
                        />
                        <i style="float: right;
                            left: -7px;
                            cursor: pointer;
                            margin-top: -25px;
                            position: relative;
                            font-size: 12px;
                            z-index: 2;" @mouseover="showPass('#password')" @mouseout="showPass('#password')" class="fa fa-eye"></i>
                      </div>
                      <!--<div class="mb-3">
                        <input
                          id="company"
                          type="text"
                          class="form-control"
                          name="company"
                          v-model="empresa"
                          placeholder="Company"
                          isRequired="required"
                        />
                      </div>-->
                      <div class="mb-3">
                        <Multiselect
                          style="border-radius: 0.5rem; font-size: 14px;"
                          v-model="industria.value"
                          v-bind="industria"
                          placeholder="Select an industry"
                        ></Multiselect>
                      </div>
                      <div class="mb-3">
                        <Multiselect
                          style="border-radius: 0.5rem; font-size: 14px;"
                          v-model="rol.value"
                          v-bind="rol"
                          placeholder="Select your position"
                        ></Multiselect>
                      </div>
                      <!--<div class="mb-3">
                        <input
                          id="password2"
                          type="password"
                          class="form-control"
                          name="password2"
                          v-model="password2"
                          placeholder="Repeat password"
                          isRequired="required"
                        /> 
                        <i style="float: right;
                            left: -7px;
                            cursor: pointer;
                            margin-top: -25px;
                            position: relative;
                            font-size: 12px;
                            z-index: 2;" @mouseover="showPass('#password2')" @mouseout="showPass('#password2')" class="fa fa-eye"></i>
                      </div>

                      <div data-size="invisible" class="h-captcha" data-sitekey="f4967c53-6d76-4c23-8d45-cadd21b49bd0"></div>-->

                      <soft-checkbox
                        style="min-width: 300px; max-width: 400px;"
                        id="flexCheckDefault"
                        name="flexCheckDefault"
                        class="font-weight-light"
                        :checked="checked"

                      >
                        I agree the
                        <a href="https://www.tomate.ai/terms" target="blank_" class="text-dark font-weight-bolder"
                          >Terms and Conditions</a
                        > and the <a href="https://www.tomate.ai/privacy" target="blank_" class="text-dark font-weight-bolder"
                          >Privacy Policy</a> (ToMate doesn't share any personal data in emails with third parties)
                      </soft-checkbox>

                      <div class="text-center">
                        <soft-button
                          color="success"
                          full-width
                          class="my-2 mb-2 h-captcha" data-sitekey="f4967c53-6d76-4c23-8d45-cadd21b49bd0" @click="captchaChecker()"
                          >
                          <span v-show="loader" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>&nbsp;&nbsp;&nbsp;
                          Sign up</soft-button
                        >
                      </div>
                      <p class="text-sm mt-1 mb-2">
                        Already have an account?
                        <router-link
                          :to="{ name: 'Sign In' }"
                          class="text-dark font-weight-bolder"
                        >
                          Log in
                        </router-link>
                      </p>
                      <span style="font-size: 10px; display: block;" class="font-weight-light">This site is protected by hCaptcha and its
                        <a href="https://www.hcaptcha.com/privacy">Privacy Policy</a> and
                        <a href="https://www.hcaptcha.com/terms">Terms of Service</a> apply.
                      </span>
                  </div>
                </div>
                <br>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
  <app-footer-entrada class="footer" />
</template>

<script>
//import Navbar from "@/examples/PageLayout/Navbar.vue";
import AppFooterEntrada from "@/examples/PageLayout/FooterEntrada.vue";
import SoftCheckbox from "@/components/SoftCheckbox.vue";
import SoftButton from "@/components/SoftButton.vue";
import HTFetch from "../llamadas/HTFetch"
import K from "../llamadas/K"
import SoftAlert from "@/components/SoftAlert.vue";
import router from '../router/index'
import Multiselect from '@vueform/multiselect'

import { mapMutations } from "vuex";

export default {
  name: "SignupBasic",
  components: {
    //Navbar,
    AppFooterEntrada,
    SoftCheckbox,
    SoftButton,
    SoftAlert,
    Multiselect 
  },
  data() {
    return {
      email: "",
      password1: "",
      password2: "",
      captcha: "captchadeprueba",
      empresa: "",
      puesto: "",
      checked: true,
      K: new K(),
      llamada: new HTFetch(),
      passwordsNotEqual: false,
      passwordNotLong: false,
      emailValid: false,
      companyEmpty: false,
      userExists: false,
      errorServer: false,
      responseMessage: "",
      showResponseMessage: false,
      loader: false,
      industria: {
        value: [],
        closeOnSelect: true,
        options: [
          'Customer Support',
          'Finance and Banking',
          'Healthcare',
          'Legal Services',
          'E-commerce',
          'Education',
          'Information Technology',
          'Insurance',
          'Other'
        ],
      },
      rol: {
        value: [],
        closeOnSelect: true,
        options: [
          "Head of Customer Support",
          "Customer Support Manager",
          "Customer Support Agent",
          "Marketing Manager", 
          "Small Business Owner",
          "Sales Representative",
          "HR Manager",
          "Business Consultant",
          "E-commerce Store Owner",
          "Legal Professional",
          "Executive Assistant",
          "Entrepreneur or Startup Founder",
          "Other"
        ]
      },
      interval: null
    }
  },
  created() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },
  beforeUnmount() {
    this.toggleEveryDisplay();
    this.toggleHideConfig();
  },

  computed: {
    captchaComputed() {
      
      return this.captcha
    },
  },

  methods: {
    ...mapMutations(["toggleEveryDisplay", "toggleHideConfig"]),

    showPass(id) {
      var input = document.querySelector(id)
      let attributeValue = input.getAttribute('type');

      console.log(attributeValue)

      if (attributeValue == "password") {
        input.setAttribute('type', 'text')
      } else {
        input.setAttribute('type', 'password')
      }
    },

    captchaChecker() {
      this.interval = setInterval(
        () => {
          this.captcha = document.querySelector('iframe').getAttribute('data-hcaptcha-response')

          if (this.captcha !== '' && this.captcha !== null) {
            this.signUp()
          }
        }, 500
      )
    },

    signUp() {

      if (!this.email.includes('@')) {
        this.emailValid = true

        setTimeout(() => {
          this.emailValid = false
        }, 2000)
        return
      }
 
      if (this.password1.length < 8) {
        this.passwordNotLong = true

        setTimeout(() => {
          this.passwordNotLong = false
        }, 2000)
        return
      }

      /*if (this.password1 !== this.password2) {
        this.passwordsNotEqual = true

        setTimeout(() => {
          this.passwordsNotEqual = false
        }, 2000)
        return
      }

      if (this.empresa.length === 0) {
        this.companyEmpty = true

        setTimeout(() => {
          this.companyEmpty = false
        }, 2000)
        return
      }*/

      clearInterval(this.interval)

      let body
      
      body = {
        "correo": this.email,
        "password1": this.password1,
        "password2": this.password1,
        //"empresa": this.empresa,
        "role": this.rol.value,
        "type": this.industria.value,
        "captcha": this.captcha
      }
      
      this.loader = true

      this.llamada.newClient(body, this.newClientRsp.bind(this))
    },

    newClientRsp(rsp) {
      
      if (399 < rsp.status && rsp.status < 501) {
        if ('detail' in rsp.data) {
          this.responseMessage = rsp.data.detail.toString().replace("'", "").replace("[", "").replace("]", "")
        }

        if ('Message' in rsp.data) {
          this.responseMessage = rsp.data.Message.toString().replace("'", "").replace("[", "").replace("]", "")
        }

        if ('message' in rsp.data) {
          this.responseMessage = rsp.data.message.toString().replace("'", "").replace("[", "").replace("]", "")
        }

        if ('Error' in rsp.data) {
          this.responseMessage = rsp.data.Error.toString().replace("'", "").replace("[", "").replace("]", "")
        }

        if ('username' in rsp.data) {
          this.responseMessage = rsp.data.username.toString().replace("'", "").replace("[", "").replace("]", "")
        }

        if ('password' in rsp.data) {
          this.responseMessage = rsp.data.password.toString().replace("'", "").replace("[", "").replace("]", "")
        }

        if ('type' in rsp.data) {
          this.responseMessage = rsp.data.type.toString().replace("'", "").replace("[", "").replace("]", "")
        }

        if ('rol' in rsp.data) {
          this.responseMessage = rsp.rol.type.toString().replace("'", "").replace("[", "").replace("]", "")
        }

        if ('captcha' in rsp.data) {
          this.responseMessage = rsp.captcha.type.toString().replace("'", "").replace("[", "").replace("]", "")
        }
        
        this.showResponseMessage = true
        this.loader = false

        setTimeout(() => {
          this.showResponseMessage = false
        }, 5000)

        return
      }

      if ('message' in rsp.data) {
        if (rsp.data.message === "user correctly created") {
          //si dio 200 hago la llamada log in
          this.llamada.Login(this.email, this.password1, this.loginRsp.bind(this))
        }
      } 
      
    },

    loginRsp(rsp) {
      
      if (rsp.status !== 401 && rsp.status !== 400 && rsp.status !== 403) {
        localStorage.ut = rsp.data.access
        localStorage.rt = rsp.data.refresh
        localStorage.user_logged = 'true'

        //checkeo tipo user
        this.llamada.userInfo(this.userInfoRsp.bind(this))
      }
      
    },

    userInfoRsp(rsp) {
      
      if (rsp.data.manager === true) {
        localStorage.manager = 'true'
      } else {
        localStorage.manager = 'false'
      }
      if (rsp.data.inserter === true) {
        localStorage.inserter = 'true'
      } else {
        localStorage.inserter = 'false'
      }

      localStorage.pack = rsp.data.premium

      let collecciones = []
      for (let i = 0; i < Object.keys(rsp.data.collections).length; i++) {
        collecciones.push({
          "name": Object.keys(rsp.data.collections)[i],
          "token": Object.values(rsp.data.collections)[i]
        })
      }

      localStorage.collections = JSON.stringify(collecciones)
      localStorage.userId = rsp.data.token

      if (this.$gtm.enabled()) {
        window.dataLayer?.push({
          event: "sign-up",
          user_id: localStorage.userId
        });
      }
      
      this.loader = false

      localStorage.tutorial_watched = "false"
      
      router.push({ name: 'Sign In' })
    }

  },
};
</script>

<style>
  @media (max-width: 450px) {
    #container {
      margin: 0 !important;
      padding: 0 !important;
    }
  }

  @media (max-width: 490px) {
    #logo {
      margin-top: 125px !important;
    }
  }
  
</style>
<style scoped>
#logoTomate {
    height: 300px;
  }
@media (max-width: 1000px) {
  #logoTomate {
    height: 250px;
  }
}
@media (min-width: 1000px) {
  #logoTomate {
    height: 300px;
  }
}
@media (max-width: 400px) {
  #logoTomate {
    height: 215px;
  }
}

@media (max-height: 870px) {
  .footer {
    display: none;
  }
}

@media (max-width: 900px) {
  .footer {
    display: none;
  }
}
</style>
